import React from 'react';

const STATUS_CONFIG = {
  connected: { color: '#34d399', label: 'Connected' },
  'in-call': { color: '#6366f1', label: 'In Call' },
  disconnected: { color: '#f87171', label: 'Disconnected' },
  error: { color: '#fbbf24', label: 'Connection Error' },
};

export default function StatusBar({ status, user, onLogout }) {
  const cfg = STATUS_CONFIG[status] || STATUS_CONFIG.disconnected;

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '8px 16px',
        background: 'rgba(255, 255, 255, 0.02)',
        borderBottom: '1px solid rgba(255, 255, 255, 0.06)',
      }}
    >
      <div
        style={{
          width: '8px',
          height: '8px',
          borderRadius: '50%',
          background: cfg.color,
          boxShadow: `0 0 6px ${cfg.color}`,
        }}
      />
      <span style={{ fontSize: '13px', color: '#cbd5e1', fontWeight: 500 }}>
        {cfg.label}
      </span>
      <span style={{ fontSize: '12px', color: '#94a3b8', marginLeft: 'auto', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', minWidth: 0 }}>
        {user?.name || 'More Profit Per Call'}
      </span>
      {onLogout && (
        <button
          onClick={onLogout}
          style={{
            background: 'none',
            border: '1px solid rgba(255, 255, 255, 0.1)',
            borderRadius: '4px',
            padding: '3px 10px',
            fontSize: '11px',
            color: '#94a3b8',
            cursor: 'pointer',
            marginLeft: '8px',
            transition: 'color 0.15s, border-color 0.15s',
          }}
        >
          Logout
        </button>
      )}
    </div>
  );
}
